import _ from 'lodash';

export function getRedirectParams(data: any) {
    const {
        state,
        current,
        change,
        invitationUserCode,
        campaignId,
        isActivated,
        redirect,
        from,
        fromService,
        product,
    } = data || {};
    let params: any = {state};
    if (current && change) {
        params = {
            ...params,
            current,
            change,
        };
    }
    else {
        params = {
            ...params,
            from,
            product,
            invitationUserCode,
            campaignId,
            isActivated,
            fromService,
            redirect: redirect ? encodeURIComponent(redirect) : redirect,
        };
    }
    const query = _.pickBy(params, val => val === 0 || !!val);
    return query;
}

export function getResultRedirectParams(query: any) {
    const {redirect, from, product} = query || {};
    const params: any = {
        from,
        product,
        redirect: redirect ? encodeURIComponent(redirect) : redirect,
    };
    const result = _.pickBy(params, val => val === 0 || !!val);
    return result || {};
}
